import Component from 'inferno-component';
import Logo from '../assets/images/logo';

class FooterNav extends Component {
  render() {
    const navItems = [
      {
        headerName: 'Word of the Day',
        headerLink: '/word-of-the-day',
        sublinks: [{ name: 'Past Words', link: '/word-of-the-day#past-words' }],
      },
      {
        headerName: 'Resources',
        headerLink: '/resources',
        sublinks: [{ name: 'Flashcards', link: '/flashcards' }],
      },
      {
        headerName: 'About',
        headerLink: '/about',
        sublinks: [{ name: 'Mission', link: '/mission' }, { name: 'Feedback', link: '/feedback' },],
      },
    ];
    const { mode } = this.props;
    const footerClass = `footer${mode ? ' footer--' + mode : ''}`;
    return (
      <div className={footerClass}>
        <div className="footer__container">
          <div className="footer__logo">
            <a href="/">
              <Logo />
            </a>
          </div>
          <div>
            {navItems.map(navItem => {
              return (
                <ul className="footer__column">
                  <li>
                    <a
                      href={navItem.headerLink}
                      className="footer__column--header"
                    >
                      {navItem.headerName}
                    </a>
                  </li>
                  <ul>
                    {navItem.sublinks.map(sublink => {
                      return (
                        <li>
                          <a href={sublink.link}>{sublink.name}</a>
                        </li>
                      );
                    })}
                  </ul>
                </ul>
              );
            })}
          </div>
          <div className="footer__foundation">
            <small>
              Created by KAI LOA Inc, with funding by the U.S. Department of Education <br />Native Hawaiian Education Programs Grant, HOOPAEPAE (S362A150055)
            </small>
          </div>
        </div>
      </div>
    );
  }
}

export default FooterNav;



// WEBPACK FOOTER //
// ./src/components/FooterNav.js